import React from 'react';
import FieldLabel from "./FieldLabel";
import FieldHint from "./FieldHint";

// Component ----

type FieldHeaderProps = {
    fieldId: string
    label?: string
    hint?: string | null
}

function FieldHeader({fieldId, label, hint}: FieldHeaderProps) {
    return (
        <div className="flex items-end justify-between">
            {/* Label */}
            {!!label && <FieldLabel htmlFor={fieldId}>{label}</FieldLabel>}

            {/* Hint */}
            {!!hint && <div className='pb-0.5'><FieldHint>{hint}</FieldHint></div>}
        </div>
    );
}

export default FieldHeader;